import gcoord from 'gcoord'
import coordtransform from 'coordtransform'

import 'leaflet.animatedmarker/src/AnimatedMarker';

var lmap = {
    initmap(id, center) {
        // this.map = L.map(id).setView([32.04569660084782,118.79396438598634], 5);
        this.map = L.map(id).setView(center.reverse(), 13)
        var url = 'http://t{s}.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=d6da39f0bfd91bdf9c4941541e18669e'
        L.tileLayer(url, {
            subdomains: '1234'
        }).addTo(lmap.map)
        L.tileLayer('http://t{s}.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=d6da39f0bfd91bdf9c4941541e18669e', {
            subdomains: '123456'
        }).addTo(lmap.map)
        lmap.map.setMinZoom(3)
        lmap.map.setMaxZoom(17)
    },
    gotoForecastCity(center) {
        let latlng
        if (Number(center[0]) > Number(center[1])) {
            latlng = [center[1], center[0]]
        } else {
            latlng = [center[0], center[1]]
        }
        /*let lnglat = gcoord.transform(
            [latlng[1], latlng[0]],
            gcoord.GCJ02,
            gcoord.EPSG4326
        )*/
        let lnglat = coordtransform.gcj02towgs84(latlng[1], latlng[0])
        //lmap.map.flyTo({lon: latlng[1], lat: latlng[0]}, 13);
        console.log(lnglat + '-+-+-+-+-+-+-+-')
        lmap.map.setView([lnglat[1], lnglat[0]], 13)
    },
    showHeadmap(time, citycode, curTreeType, header) {
        //等级太小
        var zoom = lmap.map.getZoom()
        if (zoom < 11 || !time || time == null || time == '') {
            if (lmap.headmaplayer) {
                lmap.headmaplayer.setUrl('data:image/png;charset=utf-8;base64,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')
            }
            return
        }

        //获取当前可是范围
        let tbbox = lmap.map.getBounds()
        let left = tbbox['_southWest']['lng']
        let bottom = tbbox['_southWest']['lat']
        let right = tbbox['_northEast']['lng']
        let top = tbbox['_northEast']['lat']
        let res1 = gcoord.transform([left, bottom], gcoord.EPSG4326, gcoord.GCJ02)
        let res2 = gcoord.transform([right, top], gcoord.EPSG4326, gcoord.GCJ02)
        var extents = lmap.EPSG4326_toEPSG3857([...res1, ...res2])
        var _left = extents[0]
        var _bottom = extents[1]
        var _right = extents[2]
        var _top = extents[3]
        var size = lmap.map.getSize()

        var url = header + '/image/allforecast?' + 'time=' + time + '&type=' + curTreeType + '&citycode=' + citycode + '&showWidth=' + size['x'] + '&showHeight=' + size['y'] + '&showMinx=' + _left + '&showMiny=' + _bottom + '&showMaxx=' + _right + '&showMaxy=' + _top + '&zoom=' + zoom

        var corner1 = L.latLng(bottom, left)
        var corner2 = L.latLng(top, right)
        var bounds = L.latLngBounds(corner1, corner2)
        if (lmap.headmaplayer) {
            //更新
            lmap.headmaplayer.setUrl(url)
        } else {
            //初始化
            lmap.headmaplayer = L.imageOverlay(url, bounds).addTo(lmap.map)
        }
        lmap.headmaplayer.on('load', function() {
            lmap.headmaplayer.setBounds(bounds)
        })
    },
    EPSG4326_toEPSG3857(input, opt_output, opt_dimension) {
        var length = input.length,
            dimension = opt_dimension > 1 ? opt_dimension : 2,
            output = opt_output
        if (output === undefined) {
            if (dimension > 2) {
                // preserve values beyond second dimension
                output = input.slice()
            } else {
                output = new Array(length)
            }
        }
        var halfSize = 20037508.342789244
        for (var i = 0; i < length; i += dimension) {
            output[i] = (halfSize * input[i]) / 180
            var y = 6378137 * Math.log(Math.tan((Math.PI * (input[i + 1] + 90)) / 360))
            if (y > halfSize) {
                y = halfSize
            } else if (y < -halfSize) {
                y = -halfSize
            }
            output[i + 1] = y
        }
        return output
    },
    // 道路图层
    roadLayer: {},
    // 绘制道路
    drawRoad(id = '', geojson = [], option = {}) {
        if (!id) {
            return;
        }
        const { style = {} } = option;
        const layer = L.geoJSON(geojson, {
            style: {
                color: '#1614D7',
                className: 'dashLine', // 虚线的class名称
                ...style,
            }
        }).addTo(lmap.map);
        lmap.roadLayer[id] = layer;
        console.log(layer, lmap.roadLayer);
    },
    // 清除绘制的道路
    clearRoad() {
        lmap.toggleRoad(false);
        lmap.roadLayer = {};
        // console.log(lmap.roadLayer);
    },
    // 显示/隐藏绘制的道路
    toggleRoad(show = true) {
        const layers = Object.values(lmap.roadLayer);
        layers.forEach(layer => {
            if (show) {
                lmap.map.addLayer(layer);
            } else {
                lmap.map.removeLayer(layer);
            }
        })
    },
}
export default lmap



// WEBPACK FOOTER //
// ./src/components/content/home/js/lmap.js